import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderSideIcon',
  props: {
  isBuy: { type: Boolean, required: true },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!

  return (_openBlock(), _createBlock(_component_ot_icon, {
    class: "order-side-icon order-side-icon",
    name: __props.isBuy ? 'arrow-up' : 'arrow-down'
  }, null, 8, ["name"]))
}
}

})